// Types
import type { Action } from "./types";

/**
 * Super admin actions on one person's account: the plan member's effective date
 * and a password reset.
 */

/**
 * Reads a plan member's effective date and whether it may still be changed.
 *
 * @param {string} personGuid
 * @return {*} {Action}
 */
export const fetchPersonEffectiveDate = (personGuid: string): Action => ({
  type: "FETCH_PERSON_EFFECTIVE_DATE",
  data: personGuid,
});

/**
 * Changes a plan member's effective date. `data.effectiveDate` is YYYY-MM-DD.
 *
 * @param {*} data
 * @return {*} {Action}
 */
export const updatePersonEffectiveDate = (data: {
  personGuid: string;
  effectiveDate: string;
}): Action => ({
  type: "UPDATE_PERSON_EFFECTIVE_DATE",
  data,
});

/**
 * @param {*} data
 * @return {*} {Action}
 */
export const setPersonEffectiveDate = (data: any): Action => ({
  type: "SET_PERSON_EFFECTIVE_DATE",
  data,
});

/**
 * Sends a person a new temporary password by email.
 *
 * @param {string} personGuid
 * @return {*} {Action}
 */
export const resetPersonPassword = (personGuid: string): Action => ({
  type: "RESET_PERSON_PASSWORD",
  data: personGuid,
});

/**
 * @param {*} data
 * @return {*} {Action}
 */
export const setPersonPasswordReset = (data: any): Action => ({
  type: "SET_PERSON_PASSWORD_RESET",
  data,
});

/**
 * Forgets the outcome of the last action, so a panel opened for another person
 * does not show it.
 *
 * @return {*} {Action}
 */
export const clearPersonAccount = (): Action => ({
  type: "CLEAR_PERSON_ACCOUNT",
});
